import { createFileRoute, Navigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import type { SchedulingPageFocus } from '@/features/scheduling';

function SchedulingRoute(): ReactNode {
  const focus = Route.useSearch();
  return <Navigate to="/calendar/scheduling" search={focus} replace />;
}

export const Route = createFileRoute('/scheduling')({
  validateSearch,
  component: SchedulingRoute,
});

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const SLUG_RE = /^[a-z0-9][a-z0-9-]{1,78}[a-z0-9]$/i;

function validateSearch(raw: Record<string, unknown>): SchedulingPageFocus {
  const out: SchedulingPageFocus = {};
  if (typeof raw.host === 'string' && SLUG_RE.test(raw.host)) out.host = raw.host;
  if (typeof raw.hostId === 'string' && UUID_RE.test(raw.hostId)) out.hostId = raw.hostId;
  if (typeof raw.availability === 'string' && UUID_RE.test(raw.availability)) {
    out.availability = raw.availability;
  }
  if (typeof raw.booking === 'string' && UUID_RE.test(raw.booking)) {
    out.booking = raw.booking;
  }
  return out;
}
